import { Controller } from '@hotwired/stimulus';

export default class EzController extends Controller {
  flagLoaded() {
    this.element.setAttribute('data-loaded', 'true');
  }

  get csrfToken() {
    return document.querySelector('meta[name=csrf-token]') ? document.querySelector('meta[name=csrf-token]').content : null;
  }

  get csrfParam() {
    return document.querySelector('meta[name=csrf-param]') ? document.querySelector('meta[name=csrf-param]').content : null;
  }
}
